const languageTypes = [
    { id: 1, name: "bg", title: "Български" },
    { id: 2, name: "en", title: "Английски" },
   ];
  
  export default languageTypes;
  